import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import Modal from 'react-modal';
import { Accordion, Toast } from 'react-bootstrap';
import { Context } from '../../..';
import { useNavigate } from 'react-router-dom';
import { formats, modules } from './QuillSettings';
import ReactQuill from 'react-quill';
import DocumentsService from '../../../services/DocumentsService';
import { ModalPopover } from './modal-popover';
import { MyDocsModal } from './MyDocsModal';
import { RecsNosologyModal } from './RecsNosologyModal';

interface ModalProps {
    data: any;
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const EditRecommendationsModal: FC<ModalProps> = props => {
    const { data, toggle, setToggle } = props;
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [text, setText] = useState('');
    const [type, setType] = useState('1');
    const [nosology, setNosology] = useState<any>([]);
    const [cleanData, setCleanData] = useState<boolean>(false);
    const onRequestClose = () => {
        setToggle(false);
    };

    const getRecommendation = async () => {
        if (toggle) {
            try {
                const res = await DocumentsService.getRecommendation(data["id"])
                setName(res.data["name"])
                setText(res.data["recommendation"])
                setType(res.data["type"])
                setNosology(res.data["nosology"])
            } catch (e) {
                console.log(e)
            }
        }
    }

    useEffect(() => {
        getRecommendation()
    }, [toggle])

    const saveRec = async () => {
        await DocumentsService.updateRecommendation(data["id"], { name, type, nosology, 'recommendation': text });
        setCleanData(true);
        setToggle(false)
    };

    useEffect(() => {
        if (!store.user.is_staff) {
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user.is_staff])

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <i className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
                <div className="col text-end"><Trans>Setting up recommendations</Trans></div>
            </div>
            <form className="Modal__Body">
                <div className="row form-group">
                    <div className="col-md-12">
                        <label htmlFor="recType" className="col-md-3 col-form-label"><Trans>Type</Trans></label>
                        <select className="form-control" defaultValue={type} onChange={(e: React.ChangeEvent<any>) => setType(e.target.value)}>
                            <option value='1'>Родителям</option>
                            <option value='2'>Специалистам</option>
                        </select>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="recTitle" className="col-md-3 col-form-label"><Trans>Title</Trans></label>
                        <div className="col">
                            <input type="text" className="form-control" id="recTitle" defaultValue={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-mb-12">
                        <label htmlFor="recNosology" className="col-md-3 col-form-label"><Trans>Nosologies</Trans></label>
                        <div className="col">
                            <RecsNosologyModal {...{ nosology, setNosology, cleanData, setCleanData }} />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label htmlFor="recText" className="col-md-3 col-form-label"><Trans>Recommendation</Trans></label>
                        <div className="col">
                            <ReactQuill
                                value={text}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                id="recText"
                                onChange={setText} />
                        </div>
                    </div>
                    <div className="col mt-3">
                        <button type="button" className="btn btn-success" onClick={() => saveRec()}><Trans>Save</Trans></button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};